import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from 'src/context/app';
import { useTimeAgo } from 'src/i18n';
import { ApiErrorInfo } from 'src/model/component';
import { useContextSetter } from 'src/utils/context';

import 'src/components/common/hs/hs.scss';

/** 오류 알림은 이만큼 지나면 저절로 닫는다 */
const AUTO_CLOSE_MS = 10000;

/** API 오류 알림(use-api가 AppContext.errors에 쌓는다). 모든 서비스 화면 위 오른쪽(휴대폰은 위)에 뜬다 */
export default function ApiErrorList() {
  const [{ errors }] = useContext(AppContext);

  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="HsToastStack" role="status" aria-live="polite">
      {errors.map((info) => (
        <ApiErrorToast key={info.id} info={info} />
      ))}
    </div>
  );
}

function ApiErrorToast({ info }: { info: ApiErrorInfo }) {
  const { t } = useTranslation();
  const setState = useContextSetter(AppContext);
  const timeAgo = useTimeAgo();
  const [, setTick] = useState(0);
  const { id, millis, code, message } = info;

  useEffect(() => {
    const close = () =>
      setState((state) => {
        state.errors = state.errors.filter((v) => v.id !== id);
      });
    const tick = setInterval(() => setTick((v) => v + 1), 1000);
    const timer = setTimeout(close, AUTO_CLOSE_MS);
    return () => {
      clearInterval(tick);
      clearTimeout(timer);
    };
  }, [id, setState]);

  const onClose = () => {
    setState((state) => {
      state.errors = state.errors.filter((v) => v.id !== id);
    });
  };

  return (
    <div className="HsToast danger">
      <i className="fa-solid fa-circle-exclamation icon" />
      <div className="body">
        <div className="head">
          <strong>{t('hs.error')}</strong>
          {code && <code>{code}</code>}
          <span className="time">{timeAgo.format(new Date(millis)).toString()}</span>
        </div>
        <div className="message">{message}</div>
      </div>
      <button type="button" className="hs-icon-btn" title={t('hs.close')} onClick={onClose}>
        <i className="fa-solid fa-xmark" />
      </button>
    </div>
  );
}
